<template>
  <b-modal title="Detalhes do Registro Fotográfico" v-model="show" size="xl">
    <b-container fluid>
      <b-row class="mt-2">
        <b-col cols="6">
          <b-form-group label="Título:" label-for="titulo" label-cols="2" label-align-sm="right">
            <b-form-input id="titulo" v-model="template.titulo" />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Subtítulo:" label-for="subtitulo" label-cols="2" label-align-sm="right">
            <b-form-input id="subtitulo" v-model="template.subtitulo" />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="6">
          <b-form-group label="Cores:" label-for="cor" label-cols="2" label-align="right">
            <b-form-select v-model="template.cor" :options="options">
              <template #first>
                <b-form-select-option :value="null" disabled><strong>Escolher a Cor do Relatório</strong> </b-form-select-option>
              </template>
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Imagens:" label-cols="2" label-align="right">
            <b-form-file multiple accept=".jpg" v-model="files" placeholder="Solte as fotos aqui .jpg" />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="6">
          <b-form-group label="Inspetor:" label-for="inspetor" label-cols="2" label-align="right">
            <b-form-select v-model="template.inspetor">
              <b-form-select-option v-for="profissional of getProfissionais" v-bind:key="profissional.id" :value="profissional"
                >{{ profissional.nome }}
              </b-form-select-option>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
    </b-container>

    <template #modal-footer>
      <b-button variant="secondary" @click="show = !show">Cancel</b-button>
      <b-button variant="primary" @click="carregar()">OK</b-button>
    </template>
  </b-modal>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { useProfissionalStore } from "@/stores/ProfissionalStore";
import { storeToRefs } from "pinia";
import RegistroFotografico from "@/models_reports/RegistroFotografico";

export default {
  name: "ModalDeRegistroFotografico",

  data() {
    return {
      show: false,
      files: new Array(),
      template: new RegistroFotografico(),
      color: null,
      options: [
        { value: "gray", text: "Cinza" },
        { value: "#003c5a", text: "Azul" },
        { value: "#1e5555", text: "Verde" },
        { value: "#9d0f0f", text: "Vermelho" },
        { value: "#ffbf00", text: "Amarelo" },
        { value: "#0066cc", text: "Azul Claro" },
      ],
    };
  },

  methods: {
    formatNames(files) {
      return files.length === 1 ? files[0].name : `${files.length} files selected`;
    },

    carregar() {
      for (var i = 0; i < this.files.length; i++) {
        const reader = new FileReader();
        const blob = new Blob([this.files[i]]);
        reader.readAsDataURL(blob);
        switch (i) {
          case 0:
            reader.onload = (e) => {
              this.template.fotoA = e.target.result;
            };
            break;
          case 1:
            reader.onload = (e) => {
              this.template.fotoB = e.target.result;
            };
            break;
          case 2:
            reader.onload = (e) => {
              this.template.fotoC = e.target.result;
            };
            break;
          case 3:
            reader.onload = (e) => {
              this.template.fotoD = e.target.result;
            };
            break;
          case 4:
            reader.onload = (e) => {
              this.template.fotoE = e.target.result;
            };
            break;
          case 5:
            reader.onload = (e) => {
              this.template.fotoF = e.target.result;
            };
            break;
        }
      }
      this.show = !this.show;
    },

    call(registro) {
      this.show = !this.show;
      this.template = registro;
    },
  },

  setup() {
    const store = useSgcqStore();
    const profissionalStore = useProfissionalStore();
    const { getProfissionais } = storeToRefs(profissionalStore);

    return {
      store,
      profissionalStore,
      getProfissionais,
    };
  },
};
</script>

<style lang="scss" scoped></style>
